import { put, select } from 'redux-saga/effects';
import { pagesModel } from '..';
import { logger } from '../../../../shared/lib';
import { actions } from '../reducer';
import { createNotification, snackbarModel } from '../../../snackbar';
import { collaborationApi } from '../../../../shared/api';
import { teamsModel } from '../../../teams';

import { RT } from '../../../../shared/types';

export function* deletePageTab({
  payload: { pageId, tabId, cb },
}: ReturnType<typeof pagesModel.actions.deletePageTab>) {
  try {
    const currentTeam: RT<
      typeof teamsModel.selectors.selectCurrentTeamWithError
    > = yield select(teamsModel.selectors.selectCurrentTeamWithError);

    yield put(actions.setChangePageContentIsLoading(true));
    yield put(actions.setCurrentPageStatus('pending'));

    yield collaborationApi.deleteTab({
      teamId: currentTeam.id,
      pageId,
      tabId,
    });

    yield put(actions.setCurrentPageStatus('success'));
    yield put(actions.setCurrentPageIsError(false));
  } catch (e: unknown) {
    logger.error(e);

    yield put(actions.setCurrentPageStatus('error'));
    yield put(actions.setCurrentPageIsError(true));
    yield put(
      snackbarModel.actions.addNotificationAction(
        createNotification('error', 'Failed to delete tab')
      )
    );
  } finally {
    cb?.();
    yield put(actions.setChangePageContentIsLoading(false));
  }
}
